<div class="container-element">
    <app-rendered
      [childview]="item.childview || childview"
      [paramprefix]="item.paramprefix"
      [info]="info"
      *ngFor="let it of item.content"
      [item]="it" [arr]="item.content"
      [data]="data" (deleteDataEvent)="delete($event)"
      (openViewEvent)="openView($event)"
      (moveHandler)="openMove()"
      (openLinkEvent)="openLink($event)">
    </app-rendered>
    <div class="clearfix"></div>
</div>
